import { takeEvery,all,put,select,call } from 'redux-saga/effects';
import * as actions from './actions';
import * as selectors from './selectors';
import * as dailyBatchHistApi from '../../api/dailyBatchHistApi';
import { searchToFilters } from '../../common/urlUtils';
import actionFactory from '../../webcommon/header/filterheader/actions';
import * as filterHeaderSelectors from '../../webcommon/header/filterheader/selectors';

const filterHeaderId = 'DailyBatchHist';

export const filterHeaderActions = actionFactory(filterHeaderId);

export function* dailyBatchHistConnected(action){
    try {
        const initialised = yield (select(selectors.getDailyBatchHistInitialised));
        if (!initialised) {
            yield put(actions.setDailyBatchHistLoading(true));
            const filterDefinitions = yield select(selectors.getFilterDefinitions);
            yield put(filterHeaderActions.setFilterDefinitions(filterDefinitions));
            const defaultFilters = yield select(selectors.getDefaultFilters);
            yield put(filterHeaderActions.setDefaultFilters(defaultFilters));
            if (action.search === '') {
                yield put(filterHeaderActions.resetFilters());
            } else {
                const filters = searchToFilters(action.search, filterDefinitions, defaultFilters);
                yield put(filterHeaderActions.setFilters(filters));
            }
            yield put(actions.getDailyBatchHistory());

            yield put(actions.setDailyBatchHistInitialised(true));
        }
    } finally {
        yield put(actions.setDailyBatchHistLoading(false));
    }
}

export function* filterChanged(action) {
    const initialised = yield select(selectors.getDailyBatchHistInitialised);
    if (initialised) {
        const currentlyOpenFilter = yield (select(filterHeaderSelectors.getCurrentlyOpenFilter, filterHeaderId));
        if (!currentlyOpenFilter) {
            const filters = yield select(filterHeaderSelectors.getFilters, filterHeaderId);
            yield put(actions.setDateFrom(filters[0].value.from));
            yield put(actions.setDateTo(filters[0].value.to));
            yield put(actions.refreshDailyBatchHist());
        }
    }
} 

export function* getDailyBatchHistory(api, action) {
    try {
        const filters = yield select(filterHeaderSelectors.getFilters, filterHeaderId);
        const result = yield call(api.getDailyBatchHistory) //filters need to be added as an argument
        yield put(actions.getDailyBatchHistSuccess(result))
    } catch (error) {
        yield put(actions.getDailyBatchHistFailed('Failed to retrieve daily batch history'));
    }
}





export default function* rootSaga() {
    yield all([
        takeEvery(actions.DAILY_BATCH_HIST_LOADED, dailyBatchHistConnected),
        takeEvery(
            [
                filterHeaderActions.UPDATE_FILTER,
                filterHeaderActions.REMOVE_FILTER,
                filterHeaderActions.RESET_FILTERS
            ], 
            filterChanged),
        takeEvery(
            [
                actions.GET_DAILY_BATCH_HISTORY, 
                actions.REFRESH_DAILY_BATCH_HIST
            ],
            getDailyBatchHistory, dailyBatchHistApi),
    ]);
}